export function integrationDebug(...args: any[]) {
  console.debug("🔌 integration:", ...args)
}
